import styles from './Separator.module.scss'

export default function Separator () {

  return (
    <span className={styles.contentSeparator} />
  )
}